export const TIMETABLES_LOAD_SUCCESS = 'TIMETABLES_LOAD_SUCCESS';
export const TIMETABLES_LOAD_ERROR = 'TIMETABLES_LOAD_ERROR';
export const TIMETABLES_SET_POSITIONS = 'TIMETABLES_SET_POSITIONS';
export const TIMETABLES_SET_DAY = 'TIMETABLES_SET_DAY';
export const TIMETABLES_ADD_ORDER = 'TIMETABLES_ADD_ORDER';
export const TIMETABLES_REMOVE_ORDER = 'TIMETABLES_REMOVE_ORDER';
export const TIMETABLES_MOVE_ORDER = 'TIMETABLES_MOVE_ORDER';
export const TIMETABLES_SET_VIEW = 'TIMETABLES_SET_VIEW';
